//#region ../src/storage/picker-errors.ts
/**
* Read a picker call's rejection. An error NAMED `AbortError` is the
* user's dismissal - by its name alone, as `downloadBlob` has always read
* it (a `DOMException` in every browser, but the name is the contract);
* anything else - another `DOMException` (`SecurityError`,
* `NotAllowedError`), a `TypeError`, a non-error, nullish - is
* `unavailable`. A picker that throws at once, before it returns a
* promise, is read the same way. Never throws: a `name` getter that throws
* reads as `unavailable`.
*/
function classifyPickerRejection(err) {
	if (typeof err !== "object" || err === null) return "unavailable";
	try {
		return err.name === "AbortError" ? "cancelled" : "unavailable";
	} catch {
		return "unavailable";
	}
}
//#endregion
export { classifyPickerRejection };
